import React, { FC } from "react";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import Switch from "shared/components/Form/Switch";
import TextField from "shared/components/Form/TextField";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import { COLOR_BLACK } from "shared/theme/colors";
import { useBulletinDetails } from "../../context";

const General: FC = () => {
  const {
    isHighPriority,
    setIsHighPriority,
    bulletinTitle,
    bulletinDescription,
    adminNotes,
  } = useBulletinDetails();

  return (
    <ContentSection title="GENERAL">
      <FlexColumn rowGap="1rem">
        <Switch
          value={isHighPriority}
          onChange={(value) => setIsHighPriority(value)}
          label="High Priority"
        />
        <TextField
          label="Title*"
          fullWidth
          placeholder="Click here to edit text"
          required
          {...bulletinTitle.input}
          onChange={(e) => {
            bulletinTitle?.setValue(e.target.value);
            bulletinTitle.setErrors([]);
          }}
          labelColor={COLOR_BLACK}
        />
        <TextField
          id="bulletinDescription"
          label="Description*"
          fullWidth
          placeholder="Click here to edit text"
          required
          rows={7}
          multiline
          value={bulletinDescription?.input.value}
          onChange={(e) => bulletinDescription?.setValue(e.target.value)}
          labelColor={COLOR_BLACK}
        />
        <TextField
          id="adminNotes"
          label="Admin Notes"
          fullWidth
          placeholder="Enter notes"
          required
          value={adminNotes?.input.value}
          onChange={(e) => adminNotes?.setValue(e.target.value)}
          labelColor={COLOR_BLACK}
        />
      </FlexColumn>
    </ContentSection>
  );
};

export default General;
